<template>
  <v-list-tile v-if="!isEditing" avatar ripple class="it-hv">
    <v-list-tile-avatar>
      <font-awesome-icon :icon="['fal', 'flag']"></font-awesome-icon>
    </v-list-tile-avatar>
    <v-list-tile-content>
      <v-list-tile-sub-title class="caption" v-if="!isPrintEmpty">国籍</v-list-tile-sub-title>
      <v-list-tile-title>{{ printNationality }}</v-list-tile-title>
    </v-list-tile-content>
    <v-list-tile-action>
      <v-tooltip bottom>
        <v-btn flat icon slot="activator" class="blue--text text--darken-2" :loading="isThisLoading" @click="edit"><font-awesome-icon :icon="['fal', 'pencil']"/></v-btn>
        <span>編集する</span>
      </v-tooltip>
    </v-list-tile-action>
  </v-list-tile>
  <v-container v-else>
    <v-layout wrap class="pb-4">
      <v-flex xs12 class="px-3">
        <v-select
          v-model="form.nationality.content"
          label="国籍"
          item-text="label"
          item-value="code"
          :rules="rules.nationality"
          :items="getNationItems"></v-select>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
export default {
  name: 'clientAboutBasicNationality',
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      form: {
        nationality: {
          id: '',
          content: ''
        }
      },
      rules: {
        nationality: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function () {
      if (
        this.$props.data &&
        this.$props.data.nationality
      ) {
        this.$set(this.form, 'nationality', {
          id: '' + (this.$props.data.nationality.id ? this.$props.data.nationality.id : ''),
          content: this.$props.data.nationality.content ? this.$props.data.nationality.content : ''
        })
      } else {
        this.$set(this.form, 'nationality', {
          id: 'new_nationality',
          content: ''
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          type: 'nationality'
        }
      })
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        ['nationality', 'all'].includes(this.$props.status.editing)
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.status.editing === 'nationality'
      )
    },
    isLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        ['nationality', 'all'].includes(this.$props.status.loading)
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.status.loading === 'nationality'
      )
    },
    getNationItems () {
      return Object.keys(this.$meta.nations).map(key => {
        return {
          code: key,
          label: this.$meta.nations[key]
        }
      })
    },
    printNationality () {
      return (
        this.$props.data &&
        this.$props.data.nationality &&
        this.$props.data.nationality.content &&
        this.$meta.nations[this.$props.data.nationality.content]
      ) ? this.$meta.nations[this.$props.data.nationality.content] : '国籍'
    },
    isPrintEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.nationality &&
        this.$props.data.nationality.content &&
        this.$meta.nations[this.$props.data.nationality.content]
      )
    }
  }
}
</script>
